<template>
	<sf-search-layout>
		<el-row :gutter="20">
			<el-col :span="4">
				<sf-input-group
					placeholder="test_placeholder"
					:label="getMessage_('MWCC000538')"
					:inputValue="searchParams.gqmsSeq"
					:onChange="value => onChangeSearchParam_({ key: 'gqmsSeq', value })"
					:elProps="{ suffixIcon: 'icon-sf-search' }"
				/>
			</el-col>
			<el-col :span="4">
				<sf-input-group
					placeholder="파일테스트_제목"
					:label="getMessage_('QWCC000908')"
					:inputValue="searchParams.gqmsTitle"
					:onChange="value => onChangeSearchParam_({ key: 'gqmsTitle', value })"
					:elProps="{ suffixIcon: 'icon-sf-search' }"
				/>
			</el-col>
			<el-col :span="4">
				<sf-input-group
					placeholder="파일테스트_내용"
					:label="getMessage_('QWCC000909')"
					:inputValue="searchParams.gqmsConts"
					:onChange="value => onChangeSearchParam_({ key: 'gqmsConts', value })"
				/>
			</el-col>
			<el-col :span="4">
				<sf-select-group
					:label="getMessage_('MWCC000145')"
					:inputValue="searchParams.useYn"
					:options="useYnOptions"
					:onChange="value => onChangeSearchParam({ key: 'useYn', value })"
				/>
			</el-col>
			<!-- <el-col :span="4">
				<div class="sf-input-group-wrapper">
					<span class="sf-input-group-wrapper__label">{{ getMessage_('MWCC000145') }}</span>
					<el-input placeholder="class 변경" v-model="searchParams.gqmsTitle">
						<el-button slot="append" icon="el-icon-search" v-on:click="onClickSearch"></el-button>
					</el-input>
				</div>
			</el-col> -->
		</el-row>
		<!-- -->
		<template slot="button">
			<!-- <sf-button slot="append" color="info" icon="search" :v-if="isButton_(scrId, 'CR')" :onClick="onUserPopup"></sf-button> -->
			<sf-button line icon="search" :v-if="isButton_(scrId, 'CR')" :onClick="onClickSearch">{{ getButtonMsg_(scrId, 'CR') }}</sf-button>
		</template>
	</sf-search-layout>
</template>

<script>
import { serviceComputed, serviceMethods } from '@qms/UploadForm/store/helpers';
import { rootComputed } from '@/store/common/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	created() {
		//console.log('SearchView의 created 시작');
		this.$sf_toggleLoading(true);
		Promise.all([this.searchCommCd_({ commCdType: 'USE_YN', init: [] }), this.searchCommCdTypeOptions_()])
			.then(([r]) => {
				this.setUseYnOptions_(r);
			})
			.finally(() => this.$sf_toggleLoading(false));
		//console.log('SearchView의 created 종료');
	},
	data() {
		return {
			titles: {
				label: '사용자명/아이디'
			}
		};
	},
	methods: {
		...serviceMethods,
		// onClickSearch() {
		// 	this.$sf_toggleLoading(true);
		// 	this.select_().finally(() => this.$sf_toggleLoading(false));
		// },

		onClickSearch() {
			this.$sf_toggleLoading(true);
			this.getUploadFormList_({
				gqmsSeq: this.gqmsSeq,
				gqmsTitle: this.gqmsTitle,
				gqmsConts: this.gqmsConts,
				currentPage: 1,
				pageUnit: this.groups.pageUnit
			})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		onChangeSearchParam({ key, value }) {
			this.$sf_toggleLoading(true);
			this.onChangeSearchParam_({ key, value })
				.then(() => this.$store.dispatch('uploadFormStore/select_'))
				.finally(() => this.$sf_toggleLoading(false));
		},
		onUserPopup() {
			//console.log('SearchView에서 onUserPopup 실행', this.searchUserPopParams);
			this.$emit('PopupOpen', this.searchUserPopParams);
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed
	}
};
</script>

<style>
/* .el-select .el-input {
	width: 110px;
} */
/* .input-with-select .el-input-group__prepend {
	background-color: #fff;
} */
.sf-input-group-wrapper__label {
	color: aqua;
}
.search-option-wrapper__normal {
	position: relative;
}
.search-icon {
	color: var(--color-default);
	font-size: 1.5rem;
	position: absolute;
	right: 0;
	cursor: pointer;
}
</style>
